import{RP_ACTUAL_SUPPLY_MODEL_LIST, RP_ACTUAL_SUPPLY_PAGINATION, RP_ACTUAL_SUPPLY_SEARCH,RP_ACTUAL_SUPPLY_DROP_DOWN_SEARCH_YEAR}from './actionType'

export const setModelDeviceListToState = (payload) => ({
    type: RP_ACTUAL_SUPPLY_MODEL_LIST,
    payload
})

export const setSearchToState = (payload) => ({
    type: RP_ACTUAL_SUPPLY_SEARCH,
    payload
})
export const setPaginationToState = (payload) => ({
    type: RP_ACTUAL_SUPPLY_PAGINATION,
    payload
})

export const setDropDownSearchYear = (payload) => ({
    type: RP_ACTUAL_SUPPLY_DROP_DOWN_SEARCH_YEAR,
    payload
})